// @flow

import styled, { css } from 'styled-components';
import type { Theme } from '../../../../../types';
import media from '../../../../../helpers/media';
import { BOLD } from '../../../../../helpers/fontWeight';

type Props = {
  isOpen: boolean,
};

export default styled<any, Theme, Props>('h3')`
  color: ${props => props.theme.configChoice.titleColor};
  font-size: 1.125rem;
  font-weight: ${BOLD};
  margin-bottom: .5rem;
  padding: 0 .5rem;
  position: relative;

  &::after {
    border-color: ${props => props.theme.configChoice.borderColor};
    border-style: solid;
    border-width: 0 0 2px 2px;
    content: '';
    display: block;
    height: .5rem;
    width: .5rem;
    position: absolute;
    top: ${props => (props.isOpen ? '.65rem' : '.25rem')};
    right: .2rem;
    transform: ${props => (props.isOpen ? 'rotateZ(135deg)' : 'rotateZ(-45deg)')};
  }

  ${media.md(css`
    &::after {
      display: none;
    }
  `)};

`;
